const TITLE = '브라우니 | 무인매장 정기 관리·청소 대행'
const DESCRIPTION =
  '아이스크림 할인점·셀프빨래방·스터디카페 같은 무인매장을 크루가 주 2~7회 방문해 청소·점검하고 사진으로 보고해요. 정액 요금, 우리 매장 요금을 확인해 보세요.'

export const HOME_SEO = {
  title: TITLE,
  description: DESCRIPTION,
  canonical: 'https://brwnie.kr/',
  siteName: '브라우니 무인매장 관리',
  image: 'https://brwnie.kr/assets/og/photos-hero-285.jpg',
  imageAlt: '무인매장 관리, 이제 매일 안 가셔도 돼요',
  rssTitle: '브라우니 관리 사례·운영 가이드',
  rss: 'https://brwnie.kr/rss.xml',
}

export const HOME_ORG_JSON = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://brwnie.kr/#brand',
      name: '브라우니',
      alternateName: ['brwnie', '브라우니 무인매장 관리'],
      url: 'https://brwnie.kr/',
      logo: 'https://brwnie.kr/assets/logo/brwnie_logo_navy.svg',
      description:
        '무인매장 정기 관리 서비스예요. 브라우니 크루가 정해진 요일에 무인매장을 방문해 청소·상품 진열·소모품 보충·기기 점검을 하고, 관리 완료 사진과 매장 이슈 사항을 앱으로 사장님께 보고해요.',
      telephone: '+82-2-508-0913',
      areaServed: ['서울특별시', '경기도 일부', '인천광역시 일부', '부산광역시 일부', '김해시 일부'],
      parentOrganization: { '@id': 'https://www.wkdk.kr/#org' },
      sameAs: [
        'https://blog.naver.com/higherx',
        'https://www.facebook.com/brwniebrwnie/',
        'https://www.instagram.com/brwniebrwnie/',
        'https://www.youtube.com/@-brwnie-kv3hn',
        'https://pf.kakao.com/_aDlss',
      ],
    },
    {
      '@type': 'Organization',
      '@id': 'https://www.wkdk.kr/#org',
      name: '(주)하이어엑스',
      alternateName: ['HigherX', '하이어엑스'],
      legalName: '(주)하이어엑스',
      url: 'https://www.wkdk.kr/',
      logo: 'https://brwnie.kr/assets/logo/brwnie_logo_navy.svg',
      description: '매장 운영 관리 앱 워키도키와 무인매장 정기 관리 서비스 브라우니를 운영하는 회사예요.',
      brand: [
        { '@type': 'Brand', name: '워키도키', alternateName: ['Workeydoki', 'wkdk'], url: 'https://www.wkdk.kr/' },
        { '@type': 'Brand', name: '브라우니', alternateName: ['brwnie', '브라우니 무인매장 관리'], url: 'https://brwnie.kr/' },
      ],
      areaServed: ['서울특별시', '경기도 일부', '인천광역시 일부', '부산광역시 일부', '김해시 일부'],
      telephone: '+82-2-508-0913',
      email: 'partnership@higherx.co.kr',
      taxID: '704-88-01152',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '의사당대로 83, 위워크 여의도점 4층',
        addressLocality: '영등포구',
        addressRegion: '서울특별시',
        addressCountry: 'KR',
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://brwnie.kr/#website',
      name: '브라우니',
      alternateName: ['brwnie', '브라우니 무인매장 관리'],
      url: 'https://brwnie.kr/',
      inLanguage: 'ko',
      publisher: { '@id': 'https://brwnie.kr/#brand' },
    },
  ],
}

export const HOME_FAQ_JSON = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '서비스 범위와 관리 시간은 어떻게 되나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '한 번 방문하면 평균 60분 동안 관리해요.\n무인매장 유형별 특화 업무 3가지와 표준 업무 9가지를 제공하고, 기본으로 매장 내부 청결 관리와 소모품 보충을 해요.\n업종별 전용 업무는 위쪽 [업종별 관리] 메뉴의 업종별 상세 페이지에서 볼 수 있어요.\n다만 아래 서비스는 하지 않아요.\n1. 바닥 물청소나 외벽 청소처럼 특수청소 전문 업체가 하는 서비스 (바닥 물걸레 관리를 원하시면 일회용 청소포와 밀대를 준비해 주세요.)\n2. 화장실 청소 (미리 상의하면 휴지·소독제 같은 소모품 보충은 할 수 있어요.)\n3. 분리수거는 분류된 휴지통에 한해 도와드려요. (쓰레기통 하나에 모든 품목을 버리는 경우 분리수거가 어려울 수 있어요.)\n4. 손이 닿지 않는 곳은 크루가 떨어질 위험이 있어 관리하기 어려워요. (예: 실내등, 천장형 에어컨, 기타 기물)',
      },
    },
    {
      '@type': 'Question',
      name: '매장 유형이나 평수와 관계없이 서비스 금액은 같나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '스터디카페를 빼면 같아요. 스터디카페는 1회 90분 전용 요금으로 4주 주 2회 348,000원부터예요(VAT 별도).\n다만 아래 경우에는 추가 요금이 생길 수 있어요.\n1. 실평수 40평 이상 매장\n2. 매장 특성상 표준 관리 시간보다 더 관리가 필요한 경우\n3. 표준 업무 외 요청에 따라 추가 업무가 필요한 경우\n첫 방문 때 크루가 실제로 관리하며 현장을 파악한 뒤, 더해질 수 있는 요금을 매니저가 따로 안내해 드려요.',
      },
    },
    {
      '@type': 'Question',
      name: '서비스는 4주 단위로만 이용할 수 있나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '정기 관리인 4주 패키지, 장기 관리인 12주·24주 패키지 중에서 고를 수 있어요.\n4주 패키지는 정기결제를 선택할 수 있어요. 정기결제를 이용하시면 마지막 관리일 5일 전에 처음 결제한 수단으로 자동 결제해 드려요.',
      },
    },
    {
      '@type': 'Question',
      name: '계약 취소와 해지는 어떻게 하나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '결제 후 서비스 시작 전에는 홈페이지 [마이페이지]에서 자유롭게 취소·해지를 신청할 수 있어요.\n서비스 시작 후 해지를 원하시면 [마이페이지]에서 해지를 신청하시거나 카카오톡 상담을 요청해 주세요. 빠르게 처리해 드려요.',
      },
    },
    {
      '@type': 'Question',
      name: '브라우니 크루는 어떤 분들인가요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '무인매장 관리에 필요한 이론·실무 교육을 마치고, 엄격한 채용 절차를 거쳐 신원이 확인된 크루들이에요.',
      },
    },
  ],
}
